export class ProfileData
{
    public name = "";
    public furigana = "";
    public nameRoman = "";
    public cellTel = "";
    public mail = "";
    public company = "";
    public div = "";
    public tel = "";
    public fax = "";
    public zip = "";
    public address1 = "";
    public address2 = "";
    public url = "";

    // CookieHelperで記録されているデータの型が異なるのでコンバートをする必要がある
    public static createFromSaveData(saveData : any)
    {
        var data = new ProfileData();
        if(saveData != null)
        {
            data.name = saveData.name;
            data.furigana = saveData.phonetic;
            data.nameRoman = saveData.nameEnglish;
            data.cellTel = saveData.cellPhoneNumber;
            data.mail = saveData.mail;
            data.company = saveData.belongs;
            data.tel = saveData.phoneNumber;
            data.fax = saveData.fax;
            data.zip = saveData.postCode;
            data.address1 = saveData.address1;
            data.address2 = saveData.address2;
            data.url = saveData.url;
        }
        return data;
    }
}